import React from "react";

export default function Slogan() {
  return (
    <div className="w-full mb-8 md:mb-0">
      <div className="block w-full md:w-1080px mx-auto">
        <h3
          className="
          h4-24-bold md:h3-36-bold
          mb-1 md:mb-4 text-center md:text-left
          text-dark-major
          "
        >
          Credit generation on Blockchain
        </h3>
        <p className="p-16-normal md:p-18-normal text-center text-dark-minor md:text-left w-full md:w-480px">
          Collaboration behaviors stored on-chain and credit built by the
          objective and subjective elements.
        </p>
      </div>
    </div>
  );
}
